import React, { ForwardRefRenderFunction, forwardRef, useImperativeHandle, useState } from "react";

import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Agent } from "../../../../../models/agent";
import { ShipmentAgent } from "../../../../../models/shipment.agent";
import Modal from "../../../../Generic/Modal";
import { NotificationToast } from "../../../../Generic/Toast/NotificationToast";
import {
  AgentInfoModalCloseButton,
  AgentInfosModalItemsWrapper,
  AgentInfoItem,
  Subtitle,
  Information,
  AgentInfoModalCopyButton,
} from "../../styles";
import useStyles, { AgentInfoItemWrapper } from "./styles";

const COPY_ICON = require("../../../../../assets/icons/copy.svg");

interface AgentInfoModalProps {
  agent?: ShipmentAgent["agent"];
}

export interface AgentInfoModalHandle {
  open: (agent?: Agent) => void;
  close: () => void;
}

const AgentInfoModal: ForwardRefRenderFunction<AgentInfoModalHandle, AgentInfoModalProps> = (
  _props,
  ref
) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const [open, setOpen] = useState<boolean>(false);
  const [agent, setAgent] = useState<Agent>();

  function copyValue(value?: string) {
    if (value) {
      navigator.clipboard.writeText(value);
      NotificationToast.success(translate("copiedSuccessfully"));
    }
  }

  const onOpenModal = (agent?: Agent) => {
    setAgent(agent);
    setOpen(true);
  };

  useImperativeHandle(ref, () => ({
    open: onOpenModal,
    close: () => setOpen(false),
  }));

  return (
    <>
      <Modal
        title={translate("agentContactDetails")}
        open={open}
        handleClose={() => {
          setAgent(undefined);
          setOpen(false);
        }}
        showModalFooter
        customRightButtons={
          <AgentInfoModalCloseButton
            onClick={() => {
              setAgent(undefined);
              setOpen(false);
            }}
          >
            {translate("cancel")}
          </AgentInfoModalCloseButton>
        }
        className={classes.modalBody}
      >
        <AgentInfosModalItemsWrapper>
          <AgentInfoItemWrapper item xs={12}>
            <AgentInfoItem>
              <Subtitle>{translate("name")}</Subtitle>
              <Information>{agent?.entity ?? "—"}</Information>
            </AgentInfoItem>
            <Tooltip title={translate("copy")} placement="top">
              <AgentInfoModalCopyButton onClick={() => copyValue(agent?.entity)}>
                <img src={COPY_ICON} alt="copy information icon" />
              </AgentInfoModalCopyButton>
            </Tooltip>
          </AgentInfoItemWrapper>
          <AgentInfoItemWrapper item xs={12}>
            <AgentInfoItem>
              <Subtitle>{translate("email")}</Subtitle>
              <Information>{agent?.email ?? "—"}</Information>
            </AgentInfoItem>
            <Tooltip title={translate("copy")} placement="top">
              <AgentInfoModalCopyButton onClick={() => copyValue(agent?.email)}>
                <img src={COPY_ICON} alt="copy information icon" />
              </AgentInfoModalCopyButton>
            </Tooltip>
          </AgentInfoItemWrapper>
          <AgentInfoItemWrapper item xs={12}>
            <AgentInfoItem>
              <Subtitle>{translate("phone")}</Subtitle>
              <Information>{agent?.phone ?? "—"}</Information>
            </AgentInfoItem>
            <Tooltip title={translate("copy")} placement="top">
              <AgentInfoModalCopyButton onClick={() => copyValue(agent?.phone)}>
                <img src={COPY_ICON} alt="copy information icon" />
              </AgentInfoModalCopyButton>
            </Tooltip>
          </AgentInfoItemWrapper>
        </AgentInfosModalItemsWrapper>
      </Modal>
    </>
  );
};

export default forwardRef(AgentInfoModal);
